import { Text } from "@pallet-hq/hegel"

const CollectiveTitleSection = () => (
    <>
        <Text
            variant="titleLarge"
            mb={["small", "medium", "medium"]}
            textAlign="center"
        >
            Access curated candidates, only available here
        </Text>
        <Text
            variant="headlineMedium"
            color="gray600"
            textAlign="center"
            style={{ maxWidth: "700px" }}
        >
            Meet candidates who&apos;ve trusted me to refer them to the right
            opportunities.
        </Text>
    </>
)

export default CollectiveTitleSection
